import script from "./Adress.vue?vue&type=script&setup=true&lang=js"
export * from "./Adress.vue?vue&type=script&setup=true&lang=js"

import "./Adress.vue?vue&type=style&index=0&id=1dd130d1&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd130d1"]])

export default __exports__